import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';


const EditRole = ({roleId, list }) => {
    const [roleData, setRoleData] = useState(null);
    // const [permissions, setPermissions] = useState([]);
    // const [selectedPermissions, setSelectedPermissions] = useState([]);

    const fetchRole = async (Id) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/role/${Id}`)
            .then(response => {
                setRoleData(response.data.data.role);
                // setSelectedPermissions(response.data.data.rolePermissions.map(perm => perm.id));
            })
            .catch(error => {
                console.log(error);
                setRoleData([]); 
            });
    }

    // const fetchPermissions = async () => {
    //     try {
    //         const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/permissions`);
    //         setPermissions(response.data.data);
    //     } catch (error) {
    //         console.error("Error fetching permissions!", error);
    //         setPermissions([]);
    //     }
    // }

    useEffect(() => {
        if (roleId) {
            fetchRole(roleId);
            // fetchPermissions();
        }
    },[roleId]);

    // VALIDATION RULES
    const schema = Yup.object().shape({
        name: Yup.string().required(),
    });

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (roleData) {
            reset(roleData);
        }
    }, [roleData, reset]);

    // const handlePermissionChange = (id, isChecked) => {
    //     if (isChecked) {
    //         setSelectedPermissions([...selectedPermissions, id]);
    //     } else {
    //         setSelectedPermissions(selectedPermissions.filter(permissionId => permissionId !== id));
    //     }
    // }

    const onSubmit = async (data) => {
        axiosInstance.patch(`${process.env.REACT_APP_API_URL}/role/${roleId}`, {
                ...data,
                // permissions: selectedPermissions
            })
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                closeModal(`edit_role_${roleId}`);
                list();
            })
            .catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
            });
    }

    if (!roleId || !roleData) {
        return null;
    }

    return (
        <div id={`edit_role_${roleId}`}  className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Role</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Role Name <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" defaultValue={roleData.name} {...register('name')} />
                                        <div className="text-sm text-danger">
                                            {errors.name && <p>{errors.name.message}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="table-responsive m-t-15">
                                <table className="table table-striped custom-table">
                                    <thead>
                                        <tr>
                                            <th colSpan={3}>Permissions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {permissions.length > 0 ? (
                                            permissions.map((perm) => (
                                                <tr key={perm.id}>
                                                    <td>{perm.name}</td>
                                                    <td className="text-center">
                                                        <label className="custom_check">
                                                            <input
                                                                type="checkbox"
                                                                onChange={(e) => handlePermissionChange(perm.id, e.target.checked)}
                                                                checked={selectedPermissions.includes(perm.id)}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={3}>No records found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div> */}

                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">SUBMIT</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditRole